module.exports = __webpack_public_path__ + "static/fitlogo-570302b6c454b97a0a4a5cb8bdc76152.png";